import React from "react";
import s from './CourseSectionBody.module.scss';
import ICard from "../../../../models/view/common/ICard";
import Card2 from "../../../common/Card2";
import {UnlockedSongs} from "./UnlockedSongs/UnlockedSongs";

interface ICourseSectionBodyProps {
  cards: ICard[],
  cardClicked?: (card: ICard) => void;
  quantityOfNewSongs: number;
  sectionId: number;
}

export default function CourseSectionBody({cards, cardClicked, quantityOfNewSongs, sectionId}: ICourseSectionBodyProps) {
  const cardElements = createCards(cards, cardClicked);

  return (
    <div className={s.courseSectionBody}>
      <div className={s.cards2}>
        {cardElements}
        {quantityOfNewSongs > 0
          ? <UnlockedSongs quantityOfNewSongs={quantityOfNewSongs} sectionId={sectionId}/>
          : null
        }
      </div>
    </div>
  );
}

function createCards(cards: ICard[], cardClicked: (card: ICard) => void = (_c) => {}) {
  return cards.map((c, i) => <Card2 key={`card-${i}`} cardModel={c} onClick={() => cardClicked(c)} showLessonNumbers={true} />);
}
